import { create } from 'zustand'
import axios from 'axios'
import toast from 'react-hot-toast'
import { CartItem, CartSummary } from '../types'

interface CartState {
  items: CartItem[]
  summary: CartSummary
  isLoading: boolean
  fetchCart: () => Promise<void>
  addToCart: (productId: number, quantity?: number) => Promise<boolean>
  updateQuantity: (cartId: number, quantity: number) => Promise<boolean>
  removeFromCart: (cartId: number) => Promise<boolean>
  clearCart: () => Promise<boolean>
}

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://cloudflare-ecommerce-api.hilal-b8d.workers.dev/api'

export const useCartStore = create<CartState>((set, get) => ({
  items: [],
  summary: {
    subtotal: 0,
    total: 0,
    itemCount: 0
  },
  isLoading: false,

  fetchCart: async () => {
    set({ isLoading: true })
    try {
      const response = await axios.get(`${API_BASE_URL}/cart`)
      set({
        items: response.data.items,
        summary: response.data.summary,
        isLoading: false
      })
    } catch (error: any) {
      console.error('Fetch cart error:', error)
      set({ isLoading: false })
    }
  },

  addToCart: async (productId: number, quantity = 1) => {
    try {
      await axios.post(`${API_BASE_URL}/cart/add`, {
        productId,
        quantity
      })
      
      // Refresh cart
      await get().fetchCart()
      toast.success('Produk ditambahkan ke keranjang!')
      return true
    } catch (error: any) {
      const message = error.response?.data?.error || 'Gagal menambahkan ke keranjang'
      toast.error(message)
      return false
    }
  },

  updateQuantity: async (cartId: number, quantity: number) => {
    try {
      await axios.put(`${API_BASE_URL}/cart/${cartId}`, {
        quantity
      })
      
      // Refresh cart
      await get().fetchCart()
      return true
    } catch (error: any) {
      const message = error.response?.data?.error || 'Gagal mengupdate quantity'
      toast.error(message)
      return false
    }
  },

  removeFromCart: async (cartId: number) => {
    try {
      await axios.delete(`${API_BASE_URL}/cart/${cartId}`)
      
      // Refresh cart
      await get().fetchCart()
      toast.success('Item dihapus dari keranjang!')
      return true
    } catch (error: any) {
      const message = error.response?.data?.error || 'Gagal menghapus item'
      toast.error(message)
      return false
    }
  },

  clearCart: async () => {
    try {
      await axios.delete(`${API_BASE_URL}/cart`)
      
      set({
        items: [],
        summary: {
          subtotal: 0,
          total: 0,
          itemCount: 0
        }
      })
      
      toast.success('Keranjang dikosongkan!')
      return true
    } catch (error: any) {
      const message = error.response?.data?.error || 'Gagal mengosongkan keranjang'
      toast.error(message)
      return false
    }
  }
}))
